import { Component, Input, HostBinding } from '@angular/core';


@Component({
	selector: 'button[app-session-attachments-button]',
	templateUrl: './session-attachments-button.component.html',
	styleUrls: ['./session-attachments-button.component.scss'],
	imports: []
})
export class SessionAttachmentsButtonComponent {
	@HostBinding() private class = 'btn btn-xs';
	@Input() public attachmentsCount: number = 0;
	@Input() public ariaLabel: string = 'open attachments';
	@Input() public showBadge: boolean = true;
}
